import { sagaActions } from '@/redux/sagaActions'
import { RootState } from '@/redux/reducers'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

export const useGetTicketViewOnly = (transactionId?: string) => {
  const dispatch = useDispatch()
  const { ticketData, isLoading, error } = useSelector(
    (state: RootState) => state.viewTicket,
  )
  useEffect(() => {
    if (transactionId) {
      dispatch({
        type: sagaActions.FETCH_VIEW_TICKET,
        payload: { transactionId },
      })
    }
  }, [dispatch, transactionId])

  return { ticketData, isLoading, error }
}
